export default __webpack_public_path__ + "static/media/breakfast.4da77b5f.jpg";